import { useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import { OfferReservationBanner } from '@/components/OfferReservationBanner';
import { Button } from '@/ui/components/Button';
import { Icon } from '@/ui/icons/Icon';
import { voltAppIcon } from '@/assets/images/offer/partner';
import { externalUrls } from '@/constants/urls';
import { useKyc } from '@/features/kyc';
import { routes } from '@/routes/routes';
import { trackingService } from '@/lib/tracking';
import { getPreliminaryOffers } from '@/lib/offerUtils';
import { useLoanOffer } from '../../hooks';
import styles from './PreliminaryAppRedirectPage.module.scss';

/**
 * Behind a PostHog flag: after the calculator the
 * user is pointed to the app for KYC and the card, or continues on the web.
 */
export function PreliminaryAppRedirectPage() {
  const navigate = useNavigate();
  const { isKycLoading, isKycValid } = useKyc(true);
  const { loanOfferState, isLoading } = useLoanOffer(true);

  useEffect(() => {
    void trackingService.trackEvent('preliminary_app_redirect_shown');
  }, []);

  if (isKycLoading || isLoading) {
    return <PageLoader />;
  }

  if (isKycValid || getPreliminaryOffers(loanOfferState?.creditOffers).length === 0) {
    return <Navigate to={routes.offer.preliminary} replace />;
  }

  return (
    <div className={styles.root}>
      <OfferReservationBanner />

      <div className={styles.content}>
        <div className={styles.appIcon}>
          <img src={voltAppIcon} alt="" className={styles.appIconImage} />
        </div>
        <div className={styles.text}>
          <h1 className={styles.title}>E mai rapid în aplicație</h1>
          <p className={styles.description}>
            Descarcă aplicația Volt și finalizează pașii pentru KYC și
            introducere card de două ori mai repede. Obține banii rapid!
          </p>
        </div>
      </div>

      <div className={styles.bottomSection}>
        <Button
          trackingId="preliminary_app_redirect_open_app"
          text="Continuă în aplicație"
          rightIcon={<Icon name="arrow-right" />}
          onClick={() => {
            window.location.href = externalUrls.volt.appDownload;
          }}
          className={styles.button}
        />
        <Button
          trackingId="preliminary_app_redirect_continue_web"
          variant="text"
          text="Continuă în browser"
          onClick={() => navigate(routes.kyc.base)}
          className={styles.button}
        />
      </div>
    </div>
  );
}

export default PreliminaryAppRedirectPage;
